import sc from 'styled-components/macro';
import React from 'react';

const IslandHeaderWrap = sc.div`
  display: flex;
  flex-direction: row;
  width: auto;
  padding-bottom: 24px;
  border-bottom: 1px solid #979797;
`;

const IslandTitle = sc.h1`
    margin-left: 8px;
    margin-top: 12px;
    font-size: 32px;
`;

export function IslandHeader({ title }) {

    const handleBackButtonClick = () => {
        window.history.back();
    }

    return (
        <IslandHeaderWrap>
            <button onClick={handleBackButtonClick}><img src='/icons/back-chevron.svg' /></button>
            <IslandTitle>{title}</IslandTitle>
        </IslandHeaderWrap>
    );
}

export default IslandHeader;